import axios from "axios";
import { nordNxtApiEndpoint } from "../../config/config";
import getAuthHeader from "../../utils/getAuthHeader";

export default async function getTokenStatus() {
  const { data } = await axios.get(
    `${nordNxtApiEndpoint}/check-token`,
    getAuthHeader(),
  );
  return data;
}
